import { LitElement, html, svg } from 'lit';

export class IconRatingFull16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M3.88 15.413c-.558.287-1.21-.178-1.103-.787l.786-4.5L.231 6.94c-.452-.432-.203-1.185.421-1.274l4.606-.656L7.318.916a.768.768 0 0 1 1.364 0l2.06 4.094 4.605.656c.625.09.874.842.422 1.274l-3.332 3.186.787 4.5c.106.61-.546 1.075-1.105.787L8 13.288l-4.12 2.125Z" clip-rule="evenodd"></path></svg>`; }
}
if (!customElements.get('f-icon-rating-full16', IconRatingFull16)) {
  customElements.define('f-icon-rating-full16', IconRatingFull16);
}